import {createAction} from 'typesafe-actions';

import type * as Types from './types';

export const setCustomRunColor = createAction(
  '@view/customRunColors/setCustomRunColor',
  action => (ref: Types.Ref, id: string, color: string | null) =>
    action({ref, id, color})
);
